import { MetaValue } from './Segment/__hooks/useDisabledStatus';

export interface FilterProps {
    isSticky?: boolean;
    disableWhen?: MetaValue;
}

export enum FilterKeys {
    PriceRangeSlider = 'priceRangeSlider',
    DepartureFlightTime = 'departureFlightTime',
    ReturnFlightTime = 'returnFlightTime',
    CancellationDaysBeforeTravelStart = 'cancellationDaysBeforeTravelStart',
}

export enum SectionName {
    Cancellation = 'cancellation',
    MealType = 'mealType',
    HotelCategory = 'hotelCategory',
    GuestRating = 'guestRating',
}
